export default __webpack_public_path__ + "static/media/google-playstore.38b91555.png";